import * as app from 'durandal/app';
import * as system from 'durandal/system';
import * as router from 'plugins/router';
import * as ko from 'knockout';
import CssBaseline from '@mui/material/CssBaseline';

import { isPersonaActive, isPersonaEnabled } from '@/features/verification';
import BillingDebitFailedModal from '@/legacy/features/companies/serviceSubscriptions/modals/billingDebitFailedModal';
import genericInfoModal from '@/legacy/modals/genericInfoModal';
import * as companyService from '@/legacy/services/company';
import * as promoCodesService from '@/legacy/services/company/promoCodes'; // Leave this here because we initialize an event inside
import routers from '@/legacy/services/routers';
import unsavedChangedConfirmationService from '@/legacy/services/UnsavedChangedConfirmationService';
import * as userService from '@/legacy/services/user';

declareModules({
  'components/user/companies/capabilities/freeTrialEndedBanner': () =>
    import('@/legacy/components/user/companies/capabilities/freeTrialEndedBanner'),
  'components/user/companies/capabilities/freeTrialEndedBanner.html': () =>
    import('@/legacy/components/user/companies/capabilities/freeTrialEndedBanner.html'),
  'components/user/layout/navbar-footer': () =>
    import('@/legacy/components/user/layout/navbar-footer'),
  'components/user/layout/navbar-footer.html': () =>
    import('@/legacy/components/user/layout/navbar-footer.html'),
  'components/user/layout/navbar-top': () => import('@/legacy/components/user/layout/navbar-top'),
  'components/user/layout/navbar-top.html': () =>
    import('@/legacy/components/user/layout/navbar-top.html'),
  'components/user/onboarding/parts/reminderBar': () =>
    import('@/legacy/components/user/onboarding/parts/reminderBar'),
  'components/user/onboarding/parts/reminderBar.html': () =>
    import('@/legacy/components/user/onboarding/parts/reminderBar.html'),
  'viewmodels/contacts/shell': () => import('@/legacy/viewmodels/contacts/shell'),
  'viewmodels/emailmoneytransfer/shell': () =>
    import('@/legacy/viewmodels/emailmoneytransfer/shell'),
  'viewmodels/emailSubscriptions': () => import('@/legacy/viewmodels/emailSubscriptions'),
  'viewmodels/forgotPassphrase': () => import('@/legacy/viewmodels/forgotPassphrase'),
  'viewmodels/notFound': () => import('@/legacy/viewmodels/notFound'),
  'viewmodels/oauth/shell': () => import('@/legacy/viewmodels/oauth/shell'),
  'viewmodels/quickbooksonline/shell': () => import('@/legacy/viewmodels/quickbooksonline/shell'),
  'viewmodels/register': () => import('@/legacy/viewmodels/register'),
  'viewmodels/requests/shell': () => import('@/legacy/viewmodels/requests/shell'),
  'viewmodels/resetPassphrase': () => import('@/legacy/viewmodels/resetPassphrase'),
  'viewmodels/signin': () => import('@/legacy/viewmodels/signin'),
  'viewmodels/signup': () => import('@/legacy/viewmodels/signup'),
  'viewmodels/ssoLoadingPage': () => import('@/legacy/viewmodels/ssoLoadingPage'),
  'viewmodels/ssoLogin': () => import('@/legacy/viewmodels/ssoLogin'),
  'viewmodels/user/shell': () => import('@/legacy/viewmodels/user/shell'),
  'viewmodels/verificationEmailSent': () => import('@/legacy/viewmodels/verificationEmailSent'),
  'viewmodels/verify/onetimeLogin': () => import('@/legacy/viewmodels/verify/onetimeLogin'),
  'viewmodels/verify/verifyEmail': () => import('@/legacy/viewmodels/verify/verifyEmail'),
  'viewmodels/verifyNewEmail': () => import('@/legacy/viewmodels/verifyNewEmail'),
  'viewmodels/xero/shell': () => import('@/legacy/viewmodels/xero/shell'),
  'views/contacts/shell.html': () => import('@/legacy/views/contacts/shell.html'),
  'views/emailmoneytransfer/shell.html': () =>
    import('@/legacy/views/emailmoneytransfer/shell.html'),
  'views/emailSubscriptions.html': () => import('@/legacy/views/emailSubscriptions.html'),
  'views/forgotPassphrase.html': () => import('@/legacy/views/forgotPassphrase.html'),
  'views/notFound.html': () => import('@/legacy/views/notFound.html'),
  'views/oauth/shell.html': () => import('@/legacy/views/oauth/shell.html'),
  'views/quickbooksonline/shell.html': () => import('@/legacy/views/quickbooksonline/shell.html'),
  'views/register.html': () => import('@/legacy/views/register.html'),
  'views/requests/shell.html': () => import('@/legacy/views/requests/shell.html'),
  'views/resetPassphrase.html': () => import('@/legacy/views/resetPassphrase.html'),
  'views/signin.html': () => import('@/legacy/views/signin.html'),
  'views/signup.html': () => import('@/legacy/views/signup.html'),
  'views/ssoLoadingPage.html': () => import('@/legacy/views/ssoLoadingPage.html'),
  'views/ssoLogin.html': () => import('@/legacy/views/ssoLogin.html'),
  'views/user/shell.html': () => import('@/legacy/views/user/shell.html'),
  'views/verificationEmailSent.html': () => import('@/legacy/views/verificationEmailSent.html'),
  'views/verify/onetimeLogin.html': () => import('@/legacy/views/verify/onetimeLogin.html'),
  'views/verify/verifyEmail.html': () => import('@/legacy/views/verify/verifyEmail.html'),
  'views/verifyNewEmail.html': () => import('@/legacy/views/verifyNewEmail.html'),
  'views/xero/shell.html': () => import('@/legacy/views/xero/shell.html'),
});

export class ViewModel {
  public router: DurandalRouter;

  public userService: userService.UserService;

  public companyService: companyService.CompanyService;

  private promoCodesService: promoCodesService.PromoCodeService = promoCodesService.Instance;

  private showBillingDebitFailedModalSubscription: DurandalEventSubscription;

  constructor() {
    this.router = router;
    this.companyService = companyService.Instance;
    this.userService = userService.Instance;
  }

  public react = {
    fragments: {
      /**
       * CssBaseline uses Emotion's GlobalStyle API under the hood, which bypasses the cache. Init
       * it once globally here to avoid creating thousands of redundant CSSStyleSheet instances in
       * the DOM. */
      CssBaseline,
    },
  };

  public NavigateHome(): void {
    // don't navigate anywhere when tutorial is visible

    if ($('body').hasClass('tutorial-visible')) {
      router.navigate('user/tutorials/companyInfo');
      return;
    }

    if (this.userService.IsAuthenticated() === false) {
      router.navigate('https://www.plooto.com/');
    } else {
      router.navigate('user');
    }
    $('html, body').scrollTop(0);
  }

  public ShowSignIn(): void {
    router.navigate('signin');
  }

  public SwitchCompany(): void {
    router.navigate('user/company/select');
  }

  public attached(view: HTMLElement, parent: HTMLElement): void {
    $(view)
      .find('[data-toggle=popover]')
      .popover({
        trigger: 'manual',
        html: true,
        content() {
          return $(this).parent().find('.content').html();
        },
      })
      .click(function (evt) {
        evt.stopPropagation();
        $(this).popover('show');
      });
    $('html').on('click', (e) => {
      if (
        typeof $(e.target).data('original-title') === 'undefined' &&
        !$(e.target).parents().is('.popover.in')
      ) {
        $('[data-original-title]').popover('hide');
      }
    });

    const showBillingDebitFailedModalSubscription = app
      .on('billing:showDebitFailedModal')
      .then(() => BillingDebitFailedModal.show());
  }

  public detached(): void {
    this.showBillingDebitFailedModalSubscription?.off();
  }

  public IsDemoCompany: KnockoutComputed<boolean> = ko.pureComputed({
    read: () => this.companyService.IsDemo(),
    deferEvaluation: true,
  });

  public FooterClass: KnockoutComputed<string> = ko.pureComputed({
    read: () => (this.userService.IsAuthenticated() ? 'authenticated' : 'not-authenticated'),
    deferEvaluation: true,
  });

  public IsLimitedDomesticPaymentsCompanyFeatureEnabled: KnockoutComputed<boolean> =
    ko.pureComputed({
      read: () =>
        this.userService.IsAuthenticated() &&
        this.companyService.CompanyId() &&
        this.companyService.isLimitedDomesticPaymentsFeatureEnabled(),
    });

  public SignInVisible: KnockoutComputed<boolean> = ko.pureComputed({
    read: () => {
      const instruction = router.activeInstruction();
      if (!instruction) {
        return false;
      }

      return (
        instruction.fragment != 'qbo_connect' && instruction.config.route != 'requests*details'
      );
    },
    deferEvaluation: true,
  });

  public isFooterPadded: KnockoutComputed<boolean> = ko.pureComputed({
    read: () => {
      const instruction = router.activeInstruction();
      if (!instruction) {
        return false;
      }

      return instruction.fragment.indexOf('user/onboardingWizard') !== 0;
    },
    deferEvaluation: true,
  });

  public activate(): JQueryPromise<any> {
    let lastRouteChecksum;

    router.activeInstruction.subscribe((newValue: DurandalRouteInstruction) => {
      if (!newValue || !newValue.config) {
        return;
      }
      const { moduleId } = newValue.config;

      let newRouteChecksum = newValue.config.hash;
      if (newValue.params.length > 0 && newValue.params[0] != null) {
        newRouteChecksum += '[params]';
      }

      if (lastRouteChecksum == newRouteChecksum) {
        return;
      }

      lastRouteChecksum = newRouteChecksum;

      $(document.body).toggleClass('state_authenticated', this.userService.IsAuthenticated());

      $(document.body).toggleClass('view_home', /^viewmodels\/home$/.test(moduleId));

      const navbar = $('.navbar');
      navbar.removeClass('deactivated');
      navbar.removeClass('active');
    });

    $(window).scroll(() => {
      const MIN_SCROLL_ADD = 200;
      const MIN_SCROLL_REMOVE = 100;
      const body = $(document.body);

      if (body.hasClass('view_home')) {
        const scrollTop = $(window).scrollTop();
        const navbar = $('.navbar');

        if (scrollTop > MIN_SCROLL_ADD && !navbar.hasClass('active')) {
          navbar.removeClass('deactivated');
          navbar.addClass('active');
        }
        if (scrollTop < MIN_SCROLL_REMOVE && navbar.hasClass('active')) {
          navbar.removeClass('active');
          navbar.addClass('deactivated');
        }
      }
    });

    const retVal = router
      .map([
        {
          route: [
            '',
            'signin(/:resumeFragment)',
            'signin/company/:companyId(/:resumeFragment)',
            'signin/dialog/twoFactorSettings',
          ],
          title: 'Sign In',
          moduleId: 'viewmodels/signin',
          nav: true,
        },
        { route: 'signup(/:email)', title: 'Sign Up', moduleId: 'viewmodels/signup', nav: true },

        {
          route: 'forgotPassphrase',
          title: 'Forgot Password',
          moduleId: 'viewmodels/forgotPassphrase',
          nav: true,
        },
        {
          route: 'ssoLogin',
          title: 'SSO Login',
          moduleId: 'viewmodels/ssoLogin',
          nav: true,
        },
        {
          route: 'ssoLoadingPage',
          title: 'Loading',
          moduleId: 'viewmodels/ssoLoadingPage',
          nav: false,
        },
        {
          route: 'resetPassphrase(/:userId)(/:verificationCode)',
          title: 'Reset Password',
          moduleId: 'viewmodels/resetPassphrase',
          nav: true,
        },

        {
          route: 'forwardSession/:key1/:key2/:key3',
          title: 'Logging In...',
          moduleId: 'viewmodels/verify/onetimeLogin',
          nav: true,
        },
        {
          route: 'verifyEmail/:userId/:verificationCode',
          title: 'Email Verification',
          moduleId: 'viewmodels/verify/verifyEmail',
          nav: true,
        },

        {
          route: 'verificationEmailSent(/:email)',
          title: 'Almost Done',
          moduleId: 'viewmodels/verificationEmailSent',
          nav: true,
        },
        {
          route: 'verifyNewEmail(/:userId)(/:verificationCode)',
          title: 'Verify New Email',
          moduleId: 'viewmodels/verifyNewEmail',
          nav: false,
        },

        {
          route: 'user*details',
          title: 'Dashboard',
          moduleId: 'viewmodels/user/shell',
          nav: false,
          hash: 'user',
        },

        {
          route: 'quickbooksonline*details',
          title: 'QuickBooks Online',
          moduleId: 'viewmodels/quickbooksonline/shell',
          nav: false,
          hash: 'quickbooksonline',
        },
        {
          route: 'requests*details',
          title: 'Requests',
          moduleId: 'viewmodels/requests/shell',
          nav: false,
          hash: 'requests',
        },

        {
          route: 'emailmoneytransfer*details',
          title: 'Email Money Transfer',
          moduleId: 'viewmodels/emailmoneytransfer/shell',
          nav: false,
          hash: 'emailmoneytransfer',
        },
        {
          route: 'contacts*details',
          title: 'Contact',
          moduleId: 'viewmodels/contacts/shell',
          nav: false,
          hash: 'contacts',
        },

        {
          route: 'xero*details',
          title: 'Xero',
          moduleId: 'viewmodels/xero/shell',
          nav: false,
          hash: 'xero',
        },
        {
          route: 'oauth*details',
          title: '',
          moduleId: 'viewmodels/oauth/shell',
          nav: false,
          hash: 'oauth',
        },
        {
          route: 'register(/:email)(/:verificationCode)',
          title: 'Set Password',
          moduleId: 'viewmodels/register',
          nav: false,
        },
        {
          route: 'emailSubscriptions(/:email)(/:groupId)',
          title: 'Email Subscriptions',
          moduleId: 'viewmodels/emailSubscriptions',
          nav: false,
        },
      ])
      .buildNavigationModel()
      .mapUnknownRoutes('viewmodels/notFound');
    retVal.guardRoute = (
      instance: Record<string, unknown>,
      instruction: DurandalRouteInstruction
    ): JQueryPromise<any> =>
      system
        .defer(async (dfd) => {
          if (
            unsavedChangedConfirmationService.showConfirmationDialog &&
            unsavedChangedConfirmationService.hasChanges()
          ) {
            await genericInfoModal
              .show({
                title: 'Leave page?',
                message:
                  'You have unsaved changes. Are you sure you want to leave the page without saving?',
                swapButtons: true,
              })
              .then((result) => {
                if (result === 'No') {
                  dfd.resolve(false);
                }
              });
          }

          if (
            instruction.fragment.indexOf('tutorials/') >= 0 ||
            instruction.fragment.indexOf('forwardSession/') >= 0 ||
            instruction.fragment.indexOf('user/onboardingWizard') >= 0 ||
            instruction.fragment.indexOf('user/your-first-payment/') >= 0
          ) {
            $('body').addClass('tutorial-visible');
          } else {
            $('body').removeClass('tutorial-visible');
          }

          if (
            this.userService.IsAuthenticated() &&
            this.userService.profile()?.isSignupPhoneVerificationRequired() &&
            !this.userService.profile()?.isSignupPhoneVerificationDone() &&
            (isPersonaActive().data || isPersonaEnabled().data)
          ) {
            dfd.resolve(
              instruction.fragment === 'user/tutorials/addPhoneNumber' ||
                'user/tutorials/addPhoneNumber'
            );
            return;
          }

          if (instruction.fragment == 'home' && this.userService.IsAuthenticated()) {
            dfd.resolve('user');
            return;
          }

          if (instruction.fragment == 'user' || /^user\//.test(instruction.fragment)) {
            if (!this.userService.IsAuthenticated()) {
              dfd.resolve(`signin/${encodeURIComponent(instruction.fragment)}`);
              return;
            }
          }

          // checks if the verify email route has an associated email
          if (
            this.userService.IsAuthenticated() &&
            instruction.config.moduleId === 'viewmodels/verify/verifyEmail'
          ) {
            dfd.resolve('user/company/select');
            return;
          }

          dfd.resolve(true);
        })
        .promise();

    routers.Root = retVal;

    return router.activate();
  }
}
